export default "__VITE_PUBLIC_ASSET__be775fe4__"